import React from "react";
import { useNavigate } from "react-router-dom";
import "../../Styles/UserAuthStyles/Logout.css";
import { useUser } from "../../Context/UserContext";

function Logout() {
  const navigate = useNavigate();
  const { logout } = useUser();
  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };
  return (
    <div className="verify-email-container">
      <h1>Logout</h1>
      <div>
        <button onClick={handleLogout}>Log Out!</button>
      </div>
    </div>
  );
}
export default Logout;
